var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var AppError = /** @class */ (function (_super) {
    __extends(AppError, _super);
    function AppError(message, statusCode) {
        if (statusCode === void 0) { statusCode = 500; }
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.statusCode = statusCode;
        Object.setPrototypeOf(_this, AppError.prototype);
        _this.name = 'AppError';
        return _this;
    }
    return AppError;
}(Error));
export { AppError };
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(message) {
        if (message === void 0) { message = 'Network error occurred. Please try again later.'; }
        var _this = _super.call(this, message, 503) || this;
        Object.setPrototypeOf(_this, NetworkError.prototype);
        _this.name = 'NetworkError';
        return _this;
    }
    return NetworkError;
}(AppError));
export { NetworkError };
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message, response) {
        if (message === void 0) { message = 'Validation failed.'; }
        var _this = _super.call(this, message, 400) || this;
        _this.response = response;
        Object.setPrototypeOf(_this, ValidationError.prototype);
        _this.name = 'ValidationError';
        return _this;
    }
    return ValidationError;
}(AppError));
export { ValidationError };
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(message, statusCode) {
        if (message === void 0) { message = 'Unauthorized access.'; }
        if (statusCode === void 0) { statusCode = 401; }
        var _this = _super.call(this, message, statusCode) || this;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        return _this;
    }
    return AuthError;
}(AppError));
export { AuthError };
